import React from "react";
import { setDragIds } from "../../../../../../utils/drag";
import "./TradeChip.css";

interface Props {
  /** Opaque drag identity (work-code group key) — never displayed. */
  id: string;
  /** Displayed code value + name. */
  code: string;
  label: string;
  /** The section this chip is scoped to (for the remove action). */
  section: string;
  fill: string;
  font: string;
  /** Remove this code from THIS section's trade. */
  onRemove: (id: string, section: string) => void;
}

/** One work code inside a trade bucket, scoped to one section. Drag the whole
 *  code onto another bucket to move it; ✕ removes just this section. */
const TradeChip: React.FC<Props> = ({ id, code, label, section, fill, font, onRemove }) => (
  <div
    className="tb-chip"
    draggable
    onDragStart={(e) => setDragIds(e, [id])}
    style={{ backgroundColor: fill, color: font }}
    title={`${code} – ${label} · ${section || "no section"}`}
  >
    <span className="tb-chip-code">{code}</span>
    <span className="tb-chip-label">{label}</span>
    <button
      type="button"
      className="tb-chip-x"
      onClick={(e) => {
        e.stopPropagation();
        onRemove(id, section);
      }}
      title="Remove from this section"
      aria-label="Remove from this section"
    >
      &times;
    </button>
  </div>
);

export default TradeChip;
